<template>
  <div @contextmenu.stop.prevent>
    <div
      v-if="errorMessage"
      class="q-ma-xl text-bold text-red"
    >
      Error: {{ errorMessage }}
    </div>
    <highcharts
      v-else
      ref="chart"
      :options="highchartOptions"
      class="full-width"
    />
    <report-table-cell-menu
      ref="reportTableCellMenu"
      :report-element="reportElement"
      :report-table-column="selectedColumn"
      :cell="selectedPoint"
      @edit-filter="field => editFilters(field)"
      @preview-changes="previewChanges()"
      @show-source="cell => $emit('show-source', cell)"
    />
  </div>
</template>

<script>

import { DEFAULT_CHART_OPTIONS } from 'src/models/report/ReportChart'
import { isComponentSourceCents } from 'src/models/report/ReportElement'
import ReportTableCellMenu from 'src/modules/admin/report-table/ReportTableCellMenu.vue'

export default {
  name: 'TimeSeriesChart',
  components: {
    ReportTableCellMenu
  },
  props: {
    chart: {
      type: Object,
      required: true
    },
    reportElement: {
      type: Object,
      required: true
    },
    reportOptions: {
      type: Object,
      required: true
    }
  },
  configuration: ['currentCircuit'],
  emits: ['show-source'],
  data () {
    return {
      categories: [],
      selectedPoint: {},
      selectedColumn: {}
    }
  },
  computed: {
    errorMessage () {
      return null
    },
    singleGrouping () {
      return this.reportOptions.group_by.length === 1
    },
    seriesList () {
      const seriesList = this.chart.chartData.time_series_data

      _.each(seriesList, series => {
        if (this.isMoneyOutput) {
          series.tooltip = {
            valueDecimals: 2,
            valuePrefix: this.currentCircuit?.localeCurrencySymbol || '$'
          }
        } else if (this.isPercentOutput) {
          series.tooltip = {
            valueDecimals: 0,
            valueSuffix: ' %'
          }
        }
        if (isComponentSourceCents(this.outputColumn?.component)) {
          series.data = _.map(series.data, point => {
            return [
              point[0],
              point[1] / 100
            ]
          })
        }
      })

      return _.reverse(seriesList)
    },
    outputColumn () {
      return _.find(this.reportElement.columns, { field: this.reportElement.finalOptions.output_type })
    },
    isMoneyOutput () {
      return this.outputColumn && _.includes(this.outputColumn.component, 'money')
    },
    isPercentOutput () {
      return this.outputColumn && _.includes(this.outputColumn.component, 'percent')
    },
    outputLabel () {
      if (!this.outputColumn) {
        return 'Value'
      }

      let label = this.outputColumn.label
      if (this.isMoneyOutput) {
        label += ` (${this.currentCircuit?.localeCurrencySymbol || '$'})`
      } else if (this.isPercentOutput) {
        label += ' (%)'
      }
      return label
    },

    highchartOptions () {
      return {
        ...DEFAULT_CHART_OPTIONS(),
        chart: {
          type: this.reportElement.finalOptions.chart_display_type || 'line',
          zoomType: 'x',
          resetZoomButton: {
            position: {
              align: 'right',
              verticalAlign: 'top',
              x: -10,
              y: 5
            },
            relativeTo: 'chart'
          },
          panning: true,
          panKey: 'shift',
          height: this.reportOptions.height
        },
        plotOptions: {
          area: {
            connectNulls: true,
            stacking: this.reportOptions.percent_stacking ? 'percent' : 'normal',
            marker: {
              enabled: false
            }
          }
        },
        series: this.seriesList,
        legend: {
          enabled: this.reportOptions.show_legend
        },
        xAxis: {
          type: 'datetime',
          plotBands: this.highlightTimes
        },
        yAxis: {
          title: {
            text: this.outputLabel
          },
          softMin: 0,
          softMax: 0
        }
      }
    },
    highlightTimes () {
      if (!this.chart.chartData.highlight_start_time || !this.chart.chartData.highlight_end_time) return undefined

      return [{
        from: this.chart.chartData.highlight_start_time,
        to: this.chart.chartData.highlight_end_time,
        color: 'rgba(0, 255, 0, 0.3)'
      }]
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
